import { Fee } from '@zooplus/checkout-state';
import { InfoCircle } from '@zooplus/icons';
import { P1, Tooltip } from '@zooplus/ui-components';

import styles from '@components/common/cash-on-delivery-fees/cash-on-delivery-fees.module.scss';

const CashOnDeliveryFees = (fee: Fee) => {
  const { name, description, formattedSubtotal } = fee;
  return (
    <div data-testid="cash-on-delivery-fee-wrapper" className={styles.feeWrapper}>
      <div className={styles.infoWrapper}>
        {name}
        <Tooltip
          position="right-middle"
          data-testid="cash-on-delivery-fee-info"
          tipId="cash-on-delivery-fee-info"
          tipText={description}
          tipWidth="lg">
          <InfoCircle size={20} aria-label="More information about the cash on delivery fee" />
        </Tooltip>
      </div>
      <P1 data-testid="cash-on-delivery-fee-value">{formattedSubtotal}</P1>
    </div>
  );
};

export default CashOnDeliveryFees;
